import { createSlice } from '@reduxjs/toolkit';

const DEMO_PROFILES = [
  { id: '1', name: 'Sarah', location: 'Portland, OR', bio: 'Looking for the right donor to start our family.', images: [], stats: { age: '32', height: "5'6", method: 'AI' } },
  { id: '2', name: 'James', location: 'Seattle, WA', bio: 'Happy to help intended parents on their journey.', images: [], stats: { age: '28', height: "5'11", method: 'NI' } },
  { id: '3', name: 'Emily', location: 'Denver, CO', bio: 'IP seeking a known donor for co-parenting.', images: [], stats: { age: '35', height: "5'4", method: 'AI' } },
];

const matchSlice = createSlice({
  name: 'match',
  initialState: {
    matches: DEMO_PROFILES,
    index: 0,
    history: [],
  },
  reducers: {
    matchPass: (state) => {
      state.history.push(state.matches[state.index]);
      state.index = Math.min(state.index + 1, state.matches.length);
    },
    matchLike: (state) => {
      state.index = Math.min(state.index + 1, state.matches.length);
    },
    matchUndo: (state) => {
      if (state.history.length === 0) return;
      const prev = state.history[state.history.length - 1];
      const prevIdx = state.matches.indexOf(prev);
      state.index = prevIdx >= 0 ? prevIdx : 0;
      state.history.pop();
    },
    matchReset: (state) => {
      state.index = 0;
      state.history = [];
    },
  },
});

export const { matchPass, matchLike, matchUndo, matchReset } = matchSlice.actions;
export default matchSlice.reducer;
